import { lazy } from "react";

const PrivateLayout = lazy(() => import("./PrivateLayout"));

export { PrivateLayout };
